const GA4_ID = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();

let charge = false;
let actif = false;

const idValide = (id) => /^G-[A-Z0-9]+$/i.test(id);

const preparerGtag = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
};

export const setAnalyticsConsent = (consentement) => {
  if (!idValide(GA4_ID)) return;
  preparerGtag();
  window.gtag("consent", "update", {
    analytics_storage: consentement ? "granted" : "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });

  if (!consentement) {
    actif = false;
    return;
  }
  if (charge) {
    actif = true;
    return;
  }

  charge = true;
  actif = true;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA4_ID)}`;
  document.head.appendChild(script);
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID, {
    send_page_view: false,
    anonymize_ip: true,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
};

export const trackPageView = () => {
  if (!actif || !window.gtag || window.location.pathname.startsWith("/gestion-fh-9k27")) return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname,
  });
};
